export const text = {
  categoryName: 'Nombre de categoría',
  description: 'Descripción'
};
